<template>
  <div class="logoff-finish">
    <div class="logoff-finish-main">
      <div class="logoff-finish-tit">
        <img src="@/static/finish.png" alt="">
        <h3>
        您已成功提交注销申请
        </h3>
        <h3>
          感谢您对本游戏的支持
        </h3>
      </div>
     <span>
      请注意，该账号注销有15个工作日的冷静期(账号锁定期)。除法律法规规定和注销协议约定情形外，博雅公司将在冷静期满后完成注销，删除或匿名化处理您的个人信息。在此期间，请您不要登录和使用该账号，以确保注销的顺利完成，否则视为您撤销注销申请。
    </span>
    </div>
    <div class="logoff-finish-footer">
        <button  class="next-btn"  @click="finish">完成 </button>
    </div>
  </div>
</template>
<script lang="ts">
import sendData from '../utils/difang'
export default {
  data(){
    return {
      sendData
    }
  },
  methods:{
    finish() {
      this.sendData("{'cmd':1006}".replace('#', window.location.href).replace(/\'/g,'"'))
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/btn.scss';

.logoff-finish {
    height: 100%;
    background: #fff;
    font-family: "FZLTHK--GBK1-0";
    position:absolute;
    top:0;
    bottom:0;
  &-main {
   .logoff-finish-tit{
      text-align: center;
    } 
  }
  &-footer {
      position: fixed;
      bottom:.375rem;
      left:0px;
      right:0px;
      text-align: center; 
      padding:10px;
  }
}
</style>